'use strict';

var moduleConfig = (function() {
  var applicationModuleName = 'eclipseApp';
  var applicationModuleVendorDependencies = [
    'ngAnimate',
    'ngCookies',
    // 'ngResource',
    'ui.router',
    'ui.router.tabs', // directive for tabs
    'ct.ui.router.extras',
    // 'oc.lazyLoad',
    'ngSanitize', // removed it as it was causing some mobile touch issues, can be re-added after proper investigation.
    /* 'ngTouch', // for touch devices*/

    'ngStorage', // for local storage
    'ngMessages', // messages for form validation
    'ui.bootstrap', // directives for bootstrap
    'ui.bootstrap.tpls', // templates for the bootstrap directives
    'pascalprecht.translate', // google's translate module
    'ngTable', // directive for tables
    'ute.ui', // UTE ui common modules built by UTE-UI team
    'ute.ui.chartist',
    'angularMoment', // wrapper for moment.js - related to time and date
    'uiGmapgoogle-maps', // google map from angular-ui team
    'angular-loading-bar', //https://github.com/chieffancypants/angular-loading-bar,
    'ngIdle', //FUSS-2661-This module is for automatically logging out user on session expiry
    'ute.sms.recovery.fido',
    'vcRecaptcha',
    'angular-uuid',
    'ute.easy.login.registration',
    'uteAddToCalendar',
    'ute.datalayer.common',
    'ute.fido.bpo.integration.common',
    'ute.purchase.data'
  ];

  var registerModule = function(moduleName, dependencies) {
    angular.module(moduleName, dependencies || []);
    angular.module(applicationModuleName).requires.push(moduleName);
  };

  return {
    applicationModuleName: applicationModuleName,
    applicationModuleVendorDependencies: applicationModuleVendorDependencies,
    registerModule: registerModule
  };
})();
